<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="editPersonEmergencyContactDialog"
            max-width="700px"
            persistent
        >
            <v-card>
                <DialogTitle
                    :close="closeEditItem"
                    :dialog-name="dialogName"
                />
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md8
                                sm8
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editNameErrors"
                                    @blur="$v.editName.$touch()"
                                    @input="$v.editName.$touch()"

                                    label="Name"
                                    type="text"
                                    v-model="editName"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm4
                                xs12
                            >
                                <v-select
                                    :error-messages="editRelationshipErrors"
                                    :items="relationshipTypeList"
                                    @blur="$v.editRelationship.$touch()"
                                    @input="$v.editRelationship.$touch()"
                                    label="Relationship"
                                    type="text"
                                    v-model="editRelationship"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editTelephoneErrors"
                                    @blur="$v.editTelephone.$touch()"
                                    @input="$v.editTelephone.$touch()"

                                    label="Telephone"
                                    type="text"
                                    v-model="editTelephone"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editMobilePhoneErrors"
                                    @blur="$v.editMobilePhone.$touch()"
                                    @input="$v.editMobilePhone.$touch()"

                                    label="Mobile"
                                    type="text"
                                    v-model="editMobilePhone"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editEmailAddressErrors"
                                    @blur="$v.editEmailAddress.$touch()"
                                    @input="$v.editEmailAddress.$touch()"

                                    label="Email"
                                    type="text"
                                    v-model="editEmailAddress"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editAddressLineOneErrors"
                                    @blur="$v.editAddressLineOne.$touch()"
                                    @input="$v.editAddressLineOne.$touch()"

                                    label="Address Line One"
                                    type="text"
                                    v-model="editAddressLineOne"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Address Line Two"
                                    type="text"
                                    v-model="editAddressLineTwo"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Town"
                                    type="text"
                                    v-model="editTown"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="County"
                                    type="text"
                                    v-model="editCounty"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-autocomplete
                                    :error-messages="editPersonnelCountryIdErrors"
                                    :items="personnelCountryList"
                                    @blur="$v.editPersonnelCountryId.$touch()"
                                    @input="$v.editPersonnelCountryId.$touch()"
                                    item-text="name"

                                    item-value="personnelCountryId"
                                    label="Country"
                                    v-model="editPersonnelCountryId"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editPostCodeErrors"
                                    @blur="$v.editPostCode.$touch()"
                                    @input="$v.editPostCode.$touch()"

                                    label="Postcode"
                                    type="text"
                                    v-model="editPostCode"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <DialogActions
                    :close="closeEditItem"
                    :save="saveEditItemAndCloseDialog"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from '../editTableFunctions';

    import {LOAD_PERSON_EMERGENCY_CONTACT_TO_EDIT, RESET_DEFAULT_PERSON_EMERGENCY_CONTACT_TO_EDIT, TOGGLE_EDIT_PERSON_EMERGENCY_CONTACT_DIALOG, UPDATE_EDIT_PERSON_EMERGENCY_CONTACT_FIELD} from "@/store/person_emergency_contact/mutations";
    import {FETCH_PERSON_EMERGENCY_CONTACT_LIST, SAVE_EDITED_PERSON_EMERGENCY_CONTACT} from "@/store/person_emergency_contact/actions.js";
    import {FETCH_PERSONNEL_COUNTRY_LIST} from "@/store/personnel_country/actions.js"
    import DialogTitle from "../../../../components/DialogTitle";
    import DialogActions from "../../../../components/DialogActions";
    import {email, helpers, required, requiredIf} from 'vuelidate/lib/validators'

    // eslint-disable-next-line
    const phone = helpers.regex('alpha', /^(\+\s?)?((^\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/);

    export default {
        name: "EditPersonEmergencyContactDialog",

        validations: {
            editName: {required},
            editRelationship: {required},
            editEmailAddress: {
                email
            },
            editMobilePhone: {
                required: requiredIf(function (form) {
                    return form.editTelephone === ""
                }),
                phone
            },
            editTelephone: {
                required: requiredIf(function (form) {
                    return form.editMobilePhone === ""
                }),
                phone
            },
            editAddressLineOne: {required},
            editAddressLineTwo: {},
            editTown: {},
            editCounty: {},
            editPersonnelCountryId: {required},
            editPostCode: {required},
        },

        components: {
            DialogTitle,
            DialogActions
        },

        mixins: [
            EditTableFunctions,
        ],

        data() {
            return {
                // Required for editTableFunctions
                idName: 'feedbackId',
                dialogName: "Edit Emergency Contact"
            }
        },
        computed: {
            editPersonEmergencyContactDialog: {
                get() {
                    return this.$store.state.person_employment.editPersonEmergencyContactDialog;
                },
            },
            editName: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.name;
                },
                set(value) {
                    this.updateEditedValue('name', value);
                },
            },
            editNameErrors() {
                const errors = [];
                if (!this.$v.editName.$dirty) return errors;
                !this.$v.editName.required && errors.push('required.');
                return errors
            },
            editRelationship: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.relationship;
                },
                set(value) {
                    this.updateEditedValue('relationship', value);
                },
            },
            editRelationshipErrors() {
                const errors = [];
                if (!this.$v.editRelationship.$dirty) return errors;
                !this.$v.editRelationship.required && errors.push('required.');
                return errors
            },
            editMobilePhone: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.mobilePhone;
                },
                set(value) {
                    this.updateEditedValue('mobilePhone', value);
                },
            },
            editMobilePhoneErrors() {
                const errors = [];
                if (!this.$v.editMobilePhone.$dirty) {
                    return errors;
                }
                if (!this.$v.editMobilePhone.required) {
                    errors.push('Required.');
                }
                if (!this.$v.editMobilePhone.phone) {
                    errors.push('Must be a valid phone number.');
                }

                return errors
            },
            editTelephone: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.telephone;
                },
                set(value) {
                    this.updateEditedValue('telephone', value);
                },
            },
            editTelephoneErrors() {
                const errors = [];
                if (!this.$v.editTelephone.$dirty) {
                    return errors;
                }
                if (!this.$v.editTelephone.required) {
                    errors.push('Required.');
                }
                if (!this.$v.editTelephone.phone) {
                    errors.push('Must be a valid phone number.');
                }

                return errors
            },

            editEmailAddress: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.emailAddress;
                },
                set(value) {
                    this.updateEditedValue('emailAddress', value);
                },
            },
            editEmailAddressErrors() {
                const errors = [];
                if (!this.$v.editEmailAddress.$dirty) {
                    return errors;
                } else {
                    !this.$v.editEmailAddress.email && errors.push('Must be a valid email address.');
                }
                return errors;
            },

            editAddressLineOne: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.addressLineOne;
                },
                set(value) {
                    this.updateEditedValue('addressLineOne', value);
                },
            },
            editAddressLineOneErrors() {
                const errors = [];
                if (!this.$v.editAddressLineOne.$dirty) return errors;
                !this.$v.editAddressLineOne.required && errors.push('required.');
                return errors
            },
            editAddressLineTwo: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.addressLineTwo;
                },
                set(value) {
                    this.updateEditedValue('addressLineTwo', value);
                },
            },
            editTown: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.town;
                },
                set(value) {
                    this.updateEditedValue('town', value);
                },
            },

            editCounty: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.county;
                },
                set(value) {
                    this.updateEditedValue('county', value);
                },
            },

            editPersonnelCountryId: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.personnelCountryId;
                },
                set(value) {
                    this.updateEditedValue('personnelCountryId', value);
                },
            },
            editPersonnelCountryIdErrors() {
                const errors = [];
                if (!this.$v.editPersonnelCountryId.$dirty) return errors;
                !this.$v.editPersonnelCountryId.required && errors.push('required.');
                return errors
            },
            editPostCode: {
                get() {
                    return this.$store.state.person_emergency_contact.editPersonEmergencyContact.postCode;
                },
                set(value) {
                    this.updateEditedValue('postCode', value);
                },
            },
            editPostCodeErrors() {
                const errors = [];
                if (!this.$v.editPostCode.$dirty) return errors;
                !this.$v.editPostCode.required && errors.push('required.');
                return errors
            },
            ...mapGetters(
            [
                "editPersonEmergencyContactDialog",
                "personnelCountryList",
                "relationshipTypeList"
            ]
            ),
        },

        methods: {
            fetchPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },
            ...mapActions({
                fetchTableList: FETCH_PERSON_EMERGENCY_CONTACT_LIST,
                updateTableItemRecord: SAVE_EDITED_PERSON_EMERGENCY_CONTACT,
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_EMERGENCY_CONTACT_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_EMERGENCY_CONTACT_TO_EDIT,
                updateTableItemToEdit: UPDATE_EDIT_PERSON_EMERGENCY_CONTACT_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_EMERGENCY_CONTACT_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
